import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Fragment, Suspense } from 'react';
function isOptionType(o) {
  return o.value !== undefined;
}
var AsyncSelect = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackPrefetch: true */
  /* webpackChunkName: "@atlaskit-internal_@atlassian/search-dialog/show-more/select" */'@atlaskit/select/AsyncSelect').then(function (module) {
    return {
      default: module.default
    };
  });
});
export var AsyncSelectFilterComponent = /*#__PURE__*/function (_React$Component) {
  function AsyncSelectFilterComponent(props) {
    var _this;
    _classCallCheck(this, AsyncSelectFilterComponent);
    _this = _callSuper(this, AsyncSelectFilterComponent, [props]);
    _defineProperty(_this, "onChange", function (value, _ref) {
      var action = _ref.action;
      if (isOptionType(value) && (action === 'select-option' || action === 'create-option')) {
        _this.props.onMenuClosed();
        _this.props.refocusEditLink();
        _this.props.onConfirm(value);
      }
    });
    _defineProperty(_this, "handleFocus", function () {
      _this.setState({
        menuIsOpen: true
      });
    });
    _defineProperty(_this, "handleInputChange", function (query, _ref2) {
      var action = _ref2.action;
      var inputValue = _this.state.inputValue;
      if (action === 'input-change' || action === 'set-value') {
        _this.setState({
          inputValue: query
        });
        return query;
      }
      if (action === 'menu-close') {
        // want to keep menu open if user clicks on input box
        _this.setState({
          menuIsOpen: true,
          inputValue: inputValue
        });
        // need to return inputValue to override react-select resetting
        // to empty string and clearing options if user clicks on input box
        return inputValue;
      }
    });
    _this.state = {
      menuIsOpen: false,
      inputValue: ''
    };
    return _this;
  }
  _inherits(AsyncSelectFilterComponent, _React$Component);
  return _createClass(AsyncSelectFilterComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        menuIsOpen = _this$state.menuIsOpen,
        inputValue = _this$state.inputValue;
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Fragment, null)
      }, /*#__PURE__*/React.createElement(AsyncSelect, {
        defaultOptions: this.props.defaultOptions,
        loadOptions: this.props.loadOptions,
        autoFocus: true,
        openMenuOnFocus: true,
        ariaLiveMessages: this.props.onFocusAriaMessage ? {
          onFocus: this.props.onFocusAriaMessage
        } : undefined,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        placeholder: this.props.placeholderText,
        loadingMessage: this.props.loadingMessage,
        noOptionsMessage: this.props.noOptionsMessage,
        onChange: this.onChange,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Escape') {
            _this2.props.onMenuClosed();
            e.stopPropagation();
            _this2.props.refocusEditLink();
          }
        },
        onBlur: function onBlur() {
          _this2.props.refocusEditLink();
          _this2.props.onMenuClosed();
        },
        onFocus: this.handleFocus,
        menuPosition: "fixed",
        captureMenuScroll: true,
        onInputChange: this.handleInputChange
      }));
    }
  }]);
}(React.Component);
export default AsyncSelectFilterComponent;